import { useEffect, useState } from 'react';

import { useApiContext } from '@internal/components/common/api-context';

import {
  ENRICHMENT_JOB_STORED_EVENT,
  PendingEnrichmentJob,
  readEnrichmentJob,
} from './enrichment-job-storage';

const PARSING_DISPLAY_CAP_MS = 3 * 60 * 1000;

export const useEnrichmentInProgress = (): boolean => {
  const { profile } = useApiContext();
  const [job, setJob] = useState<PendingEnrichmentJob | null>(null);
  const [capReached, setCapReached] = useState(false);

  useEffect(() => {
    const sync = () => setJob(readEnrichmentJob());

    sync();
    window.addEventListener(ENRICHMENT_JOB_STORED_EVENT, sync);
    return () => window.removeEventListener(ENRICHMENT_JOB_STORED_EVENT, sync);
  }, []);

  useEffect(() => {
    if (!job) return undefined;

    const remaining = job.storedAt + PARSING_DISPLAY_CAP_MS - Date.now();
    if (remaining <= 0) {
      setCapReached(true);
      return undefined;
    }

    setCapReached(false);
    const timer = setTimeout(() => setCapReached(true), remaining);
    return () => clearTimeout(timer);
  }, [job]);

  return Boolean(job && !capReached && profile?.apiKey === job.apiKey);
};
